import { jsx, jsxs } from "react/jsx-runtime";
function NoTask() {
    return /*#__PURE__*/ jsxs("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_988_29209)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        d: "M11 24.0586H75V64.5586H11V24.0586Z",
                        fill: "#D8DEEA"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M71 26.4941H15V60.5587H60.5V50.5587H71L71 26.4941Z",
                        fill: "#EFF2F8"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M60.5 50.5586H71L60.5 60.5586V50.5586Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        x: "11",
                        y: "17.0586",
                        width: "64",
                        height: "12",
                        fill: "#AFB9C9"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M60.4951 22.0618C61.0815 22.0618 61.5569 21.5864 61.5569 21C61.5569 20.4136 61.0815 19.9382 60.4951 19.9382V22.0618ZM64.4333 16V17.0618H66.5569V16H64.4333ZM60.4951 19.9382C58.3201 19.9382 56.5569 18.175 56.5569 16H54.4333C54.4333 19.3478 57.1473 22.0618 60.4951 22.0618V19.9382ZM56.5569 16C56.5569 13.825 58.3201 12.0618 60.4951 12.0618V9.93821C57.1473 9.93821 54.4333 12.6522 54.4333 16H56.5569ZM60.4951 12.0618C62.6701 12.0618 64.4333 13.825 64.4333 16H66.5569C66.5569 12.6522 63.8429 9.93821 60.4951 9.93821V12.0618Z",
                        fill: "#E8EDF5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M39.5 36.5586L46.5 36.5586",
                        stroke: "#AFB9C9",
                        strokeWidth: "2.02559",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M23 36.5586L30 36.5586",
                        stroke: "#AFB9C9",
                        strokeWidth: "2.02559",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M56 36.5586L63 36.5586",
                        stroke: "#AFB9C9",
                        strokeWidth: "2.02559",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M39.5 44.0586L46.5 44.0586",
                        stroke: "#AFB9C9",
                        strokeWidth: "2.02559",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M23 44.0586L30 44.0586",
                        stroke: "#AFB9C9",
                        strokeWidth: "2.02559",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M56 44.0586L63 44.0586",
                        stroke: "#AFB9C9",
                        strokeWidth: "2.02559",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M39.5 52.0586L46.5 52.0586",
                        stroke: "#AFB9C9",
                        strokeWidth: "2.02559",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M23 51.5586H31.0795",
                        stroke: "#B9BEC4",
                        strokeWidth: "2.02559"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M43 22.0618C43.5864 22.0618 44.0618 21.5864 44.0618 21C44.0618 20.4136 43.5864 19.9382 43 19.9382V22.0618ZM46.9382 16V17.0618H49.0618V16H46.9382ZM43 19.9382C40.825 19.9382 39.0618 18.175 39.0618 16H36.9382C36.9382 19.3478 39.6522 22.0618 43 22.0618V19.9382ZM39.0618 16C39.0618 13.825 40.825 12.0618 43 12.0618V9.93821C39.6522 9.93821 36.9382 12.6522 36.9382 16H39.0618ZM43 12.0618C45.175 12.0618 46.9382 13.825 46.9382 16H49.0618C49.0618 12.6522 46.3478 9.93821 43 9.93821V12.0618Z",
                        fill: "#E8EDF5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M23.9951 22.0618C24.5815 22.0618 25.0569 21.5864 25.0569 21C25.0569 20.4136 24.5815 19.9382 23.9951 19.9382V22.0618ZM27.9333 16V17.0618H30.0569V16H27.9333ZM23.9951 19.9382C21.8201 19.9382 20.0569 18.175 20.0569 16H17.9333C17.9333 19.3478 20.6473 22.0618 23.9951 22.0618V19.9382ZM20.0569 16C20.0569 13.825 21.8201 12.0618 23.9951 12.0618V9.93821C20.6473 9.93821 17.9333 12.6522 17.9333 16H20.0569ZM23.9951 12.0618C26.1701 12.0618 27.9333 13.825 27.9333 16H30.0569C30.0569 12.6522 27.3429 9.93821 23.9951 9.93821V12.0618Z",
                        fill: "#E8EDF5"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        x: "1",
                        y: "39.0586",
                        width: "30.6621",
                        height: "30.6621",
                        rx: "15.3311",
                        fill: "#D8DEEA"
                    }),
                    /*#__PURE__*/ jsx("circle", {
                        cx: "16.3308",
                        cy: "54.3889",
                        r: "11.4983",
                        fill: "white"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M16.3311 47.8203V55.0861L20.1638 58.2235",
                        stroke: "#A8B4C7",
                        strokeWidth: "2.19015",
                        strokeLinecap: "round"
                    })
                ]
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_988_29209",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "80",
                        height: "80",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
export { NoTask as default };
